"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterPill = exports.FETISHES_FILTER_OPTIONS_KEY = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var IconButton_1 = __importDefault(require("@atg/icf-react-components/components/IconButton"));
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var react_jss_1 = require("react-jss");
var Contexts_1 = require("../Contexts");
var Ioc_1 = require("../utilities/Ioc");
var HiddenText_1 = require("./HiddenText");
exports.FETISHES_FILTER_OPTIONS_KEY = "fetishes_filter_options";
var useFilterPillStyles = (0, react_jss_1.createUseStyles)(function (theme) { return ({
    filterPillItem: {
        backgroundColor: theme.colors.primary,
        borderRadius: "2px",
        marginInlineEnd: theme.spacing.base / 2,
        marginBottom: "4px",
        display: "inline-block",
        "& .root": {
            // eslint-disable-next-line @atg/css-rtl-support
            padding: "0 8px 0 0",
        },
        "& .svg": {
            fill: "rgba(0, 0, 0, 0.3)",
        },
    },
    hiddenFilterPillItem: {
        height: "32px",
        verticalAlign: "top",
    },
    pillContentWrapper: {
        display: "flex",
        width: "fit-content",
    },
    pillLabel: {
        fontSize: "14px",
        fontStyle: "normal",
        fontStretch: "normal",
        letterSpacing: "0.15px",
        color: theme.colors.textOnDark,
        margin: "8px",
        display: "inline-block",
        fontWeight: "inherit",
    },
    hiddenText: {
        height: "16px",
    },
}); });
var FilterPill = function (_a) {
    var _b;
    var _c;
    var emitTrackingEvent = _a.emitTrackingEvent, label = _a.label, onFilterClose = _a.onFilterClose, translate = _a.translate;
    var classes = useFilterPillStyles();
    var _d = __read((0, Ioc_1.useContexts)(Contexts_1.IUserContext), 1), user = _d[0];
    var isTextBlurEnabled = (_c = user === null || user === void 0 ? void 0 : user.ageVerificationRules) === null || _c === void 0 ? void 0 : _c.isTextBlurEnabled;
    var blurLabel = isTextBlurEnabled && label.includes(exports.FETISHES_FILTER_OPTIONS_KEY);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(classes.filterPillItem, (_b = {},
            _b[classes.hiddenFilterPillItem] = blurLabel,
            _b)), "data-ta-locator": "filterPill" },
        react_1.default.createElement("div", { className: classes.pillContentWrapper },
            react_1.default.createElement("div", { className: classes.pillLabel }, blurLabel ? (react_1.default.createElement(HiddenText_1.HiddenText, { text: label, width: "4rem", opacity: 0.6, className: classes.hiddenText })) : (translate(label))),
            react_1.default.createElement(IconButton_1.default, { name: "cancel", onClick: function () {
                    onFilterClose();
                    emitTrackingEvent("icfClick", "filterPillClose", "label=".concat(label));
                }, "data-ta-locator": "pillCloseButton", type: "default", size: "small", overrides: {
                    root: "root",
                    svgIcon: "svg",
                } }))));
};
exports.FilterPill = FilterPill;
exports.FilterPill.displayName = "FilterPill";
//# sourceMappingURL=FilterPill.js.map